import React from "react";

const PlaceholderCheckout = () => {
  return (
    <div className='piranha-payment-warning'>
      <strong>⚠️ Payment UI not implemented yet</strong>
      <hr />
      <div>This Payment UI for this vendor is not implemented yet.</div>
    </div>
  );
};

export default PlaceholderCheckout;
